// URL-friendly slug from a report name, e.g. "Billval invoice month gaps" ->
// "billval_invoice_month_gaps". Used so /reports/:slug URLs are readable instead of showing the
// raw numeric sk - reports_list.tsx generates the slug when navigating, report_runner.tsx resolves
// it back to the report's real sk by matching against the report list (see its own comment).
export function slugify(text: string): string {
  return text
    .toLowerCase()
    .trim()
    .replace(/[^a-z0-9]+/g, "_")
    .replace(/^_+|_+$/g, "");
}
